import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=abf9e97c&scoped=true"
import script from "./Points.vue?vue&type=script&lang=js"
export * from "./Points.vue?vue&type=script&lang=js"
import style0 from "./Points.vue?vue&type=style&index=0&id=abf9e97c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf9e97c",
  null
  
)

export default component.exports